import { IdeaEditStepProps } from "./EditIdeaPage.tsx";
import { TextField } from "@mui/material";
import { ChangeEvent, useCallback } from "react";

export default function IdeaEditStep(props: IdeaEditStepProps) {

    const [idea, setIdea] = props.control

    const handleIdeaTitleInputValueChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        let newTitle = e.target.value
        setIdea((idea) => ({ ...idea, title: newTitle }))
    }, [idea])

    return <>
        <TextField
            autoFocus
            // margin="normal"
            id="idea"
            label="Idee vorschlagen"
            type="text"
            fullWidth
            required
            defaultValue={idea.title}
            onChange={handleIdeaTitleInputValueChange}
            sx={{ marginTop: 2 }}
        />
        <TextField
            id="description"
            label="Beschreibung (optional)"
            type="text"
            multiline
            minRows={3}
            fullWidth
            defaultValue={idea.description}
            onChange={(e) => setIdea((idea) => ({ ...idea, description: e.target.value }))}
            sx={{ marginTop: 4 }}
        />
    </>
}